import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import SocketIO from "socket.io-client";
import VueSocketIO from "vue-socket.io";

Vue.config.productionTip = false;

const url = process.env.VUE_APP_BACKEND_API_ENDPOINT;
const options = {
  withCredentials: true,
};

Vue.use(
  new VueSocketIO({
    connection: SocketIO(url, options),
  })
);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");

// trigger
